export default "__VITE_ASSET__3dUWqUFl__"